<template>
  <div class="breadcrumb-V1">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item v-if="columnName !== null && columnName !== undefined">{{columnName}}</el-breadcrumb-item>
      <template v-for="item in markData" v-else>
        <!-- <el-breadcrumb-item :to="{ path: '/' }">{{ item.NAVNAME }}</el-breadcrumb-item> -->
        <el-breadcrumb-item>{{ item.NAVNAME }}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props:{
    columnName:String,
  },
  data() {
    return {
      markData: [],
    }
  },
  watch: {
    $route(to, from) {
      this.load();
    }
  },
  methods: {
    load: function () {
      if (this.$route.query.id) {
        this.markData = this.getData(this.$fun.getCacheNav(), this.$route.query.id);
      } else {
        this.markData = this.$fun.getCacheNav().filter(o => o.NAVPAGE == this.$route.path);
      }
    },
    getData: function (data, id) {
      var result = [];
      var list = data.filter(o => o.ID == id);
      if (list.length > 0) {
        if (list[0].PARENTID) {
          result.push(...this.getData(data, list[0].PARENTID, result))
        }
      }
      result.push(list[0]);
      return result;
    }
  },
  mounted: function () {
    this.load();
  }
}
</script>

<style lang="css" scoped>
.breadcrumb-V1 {
  margin-bottom: 20px;
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/common/NavMarkView.vue